import React from 'react';

import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import useDeleteAthleteEvents from 'hooks/athleteEvent/useDeleteAthleteEvents';
import { AthleteEvent } from 'types';
import notificationHandler from 'utils/notifications';

interface IDeleteAttendanceModalProps {
  opened: boolean;
  onClose: () => void;
  selectedEvents: AthleteEvent[];
}

const DeleteAttendanceModal = ({
  opened,
  onClose,
  selectedEvents,
}: IDeleteAttendanceModalProps): JSX.Element => {
  const deleteAttendanceMutation = useDeleteAthleteEvents();
  const { successNotification, errorNotification } = notificationHandler();

  const handleDelete = (): void => {
    const athleteEvents = selectedEvents.map(event => ({
      athleteEventId: event.athleteEventId,
      type: event.type,
    }));

    deleteAttendanceMutation.mutate(
      { data: { athleteEvents } },
      {
        onSuccess: () => {
          successNotification(
            'Attendance records delete success',
            `${selectedEvents.length} attendance record(s) deleted successfully.`,
          );
          onClose();
        },
        onError: error => {
          errorNotification('Attendance records delete failed', error.response?.data.message);
        },
      },
    );
  };

  return (
    <Modal opened={opened} onClose={onClose} title='Delete Attendance Records' centered trapFocus>
      <Stack>
        <Text>{`Are you sure you want to delete ${selectedEvents.length} attendance record(s)?`}</Text>
        <Text color='dimmed'>This action cannot be undone.</Text>
        <Group position='right'>
          <Button onClick={onClose} variant='default'>
            Cancel
          </Button>
          <Button onClick={handleDelete} color='red' loading={deleteAttendanceMutation.isLoading}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default DeleteAttendanceModal;
